import { RepositoryError } from './RepositoryError';
export class NetworkError extends RepositoryError {
    constructor(message, options) {
        super(message, options);
        this.name = 'NetworkError';
    }
}
